import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Divider, useMediaQuery, useTheme, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import BreadcrumbsComponent from "./Breadcrumb";
import { IconAlertTriangle, IconArrowLeft, IconFile, IconFileExport, IconLogin2, IconLogout2, IconPower, IconX } from "@tabler/icons-react";
import axios from "axios";

const Layout = ({ children, showBreadcrumbs = true }) => {
  const navigate = useNavigate();
  const [open, setopen] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const pathname = window.location.pathname;
  const pageName = pathname.split("/").pop();
  const theme = useTheme();

  const projectid = params.get("id");
  const doctype = params.get("type");
  const ext = params.get("ext");
  const projectname = params.get("name");
  const [Exportloader, setExportloader] = useState(false)
  const [loader, setloader] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [setupdata, setsetupdata] = useState()
  const isBillingAdded = setupdata?.is_billing_added
  const [Errorpopup, setErrorpopup] = useState(false)
  const getSetupData = async () => {
    try {
      const response = await axios.get('/apiV1/set-up/')
      if (response.status === 200) {
        setsetupdata(response.data)

      }
    }
    catch (err) {
      console.log(err?.response?.data?.message);
    }
  }
  useEffect(() => {
    getSetupData();
  }, []);
  const handleDownload = async () => {
    try {
      if (!isBillingAdded) {
        setErrorpopup(true);
        return;
      }
      setloader(true);
      setExportloader(true)
      const req = {
        doc_type: doctype,
        project_id: projectid
      };

      const response = await axios.post('/apiV1/download-doc/', req, {
        responseType: 'blob'
      });

      // let fileExtension = (doctype === 'doc_exec' || doctype === 'doc_full') ? 'docx' : 'pdf';
      let fileExtension =  'pdf';
      const contentDisposition = response.headers['content-disposition'];
      let filename = `${projectname}-${ext}.${fileExtension}`;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match) filename = match[1];
      }

      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setloader(false);
      setExportloader(false)
      window.location.reload()
    } catch (error) {
      console.error('Error downloading file:', error);
      setloader(false);
      setExportloader(false)

    }
  };
  
  // const handleDownload = async () => {
  //   try {
  //     setExportloader(true);
  //     const req = {
  //       doc_type: doctype,
  //       project_id: projectid
  //     };

  //     const response = await axios.post('/apiV1/download-doc/', req, {
  //       responseType: 'blob'
  //     });

  //     let fileExtension = (doctype === 'doc_exec' || doctype === 'doc_full') ? 'docx' : 'pdf';
  //     const contentDisposition = response.headers['content-disposition'];
  //     let filename = `${projectname}-${ext}.${fileExtension}`;
  //     if (contentDisposition) {
  //       const match = contentDisposition.match(/filename="?(.+?)"?$/);
  //       if (match) filename = match[1];
  //     }

  //     const blob = new Blob([response.data], { type: response.headers['content-type'] });
  //     if (window.showSaveFilePicker) {
  //       const fileHandle = await window.showSaveFilePicker({
  //         suggestedName: filename,
  //         types: [{
  //           description: fileExtension.toUpperCase(),
  //           accept: { [`application/${fileExtension}`]: [`.${fileExtension}`] }
  //         }]
  //       });

  //       const writableStream = await fileHandle.createWritable();
  //       await writableStream.write(blob);
  //       await writableStream.close();
  //     } else {
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = filename;
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //       window.URL.revokeObjectURL(url);
  //     }

  //     setExportloader(false);
  //   } catch (error) {
  //     console.error('Error downloading file:', error);
  //     setExportloader(false);
  //   }
  // };

  return (
    <>
      <Box sx={{ display: "flex", backgroundColor: "#fff" }}>
        <CssBaseline />
        <Sidebar />
        <Box component="main"
          sx={{
            flexGrow: 1,
            p: 2,
            // m: 2,
            // backgroundColor: "#f4f4f4",
            backgroundColor: "#fff",
            // borderRadius: "20px",
            // border: "1px solid #e4e4e4",
          }}
        >
          {/* Header Section */}
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center",marginTop: isMobile ? "50px" : "0px" }}>
            {/* Conditionally Render Breadcrumbs */}
            {showBreadcrumbs && <BreadcrumbsComponent />}

            {/* Logout Button */}
            {pageName === "viewdocument" && (
              <Button
                variant="contained"
                className="button2"
                sx={{ gap: 1 }}
                onClick={handleDownload}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress size={20} color="#fff" sx={{ color: "#fff" }} />
                ) : (
                  <>
                    Export
                    <IconFileExport />
                  </>
                )}
              </Button>
            )}

            {(pageName === "cardDetails"|| pageName === "createticket") && (
            <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate(-1)}>
              <IconArrowLeft /> Back
            </Button>
            )}
            {(pageName === 'documents') && (
              <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate('/dashboard')}>
                <IconArrowLeft /> Back
              </Button>
             )}
            {(pageName === 'transactionhistory' || pageName === 'billing') && (
              <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate('/plans')}>
                <IconArrowLeft /> Back
              </Button>
             )}
              {(pageName === 'invoice') && (
              <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate('/plans/transactionhistory')}>
                <IconArrowLeft /> Back
              </Button>
             )}
            {/* {(pageName === "plans") && (<Box sx={{display:"flex",gap:2,mx:2}}>
              <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate('/plans/transactionhistory')}>
                Transaction History
              </Button>
                <Button variant="contained" className="button2" sx={{ gap: 1 }} onClick={() => navigate('/plans/cardDetails')}>
                Card Details
              </Button> 
              </Box>
            )} */}

          </Box>
          <Box sx={{ 
            // boxShadow: "0px 0px 10px 0px #0000001a",
            //  borderRadius: "8px",
              padding: 2, 
              height: "96vh",
               overflow: "auto", 
              // backgroundColor: "#fff",
              scrollbarWidth:"none" }}>
            {React.cloneElement(children, { Exportloader })}
          </Box>
        </Box>
      </Box>
       <Dialog
                    open={Errorpopup}
                    onClose={() => setErrorpopup(false)}
                    aria-labelledby="error-dialog-title"
                    aria-describedby="error-dialog-description"
                    PaperProps={{
                        sx: { borderRadius: "16px", padding: "16px" },
                    }}
                    fullWidth
                    maxWidth="sm"
                >
                    {/* Close Button */}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box />
                        <IconButton size="small" onClick={() => setErrorpopup(false)}>
                            <IconX />
                        </IconButton>
                    </Box>

                    {/* Error Icon & Title */}
                    <DialogTitle id="error-dialog-title" align="center" sx={{ marginTop: -3 }}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    backgroundColor: "#fff3cd",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "50%",
                                    marginBottom: 2,
                                }}
                            >
                                <IconAlertTriangle size={32} color="#ff9800" />
                            </Box>
                        </Box>
                        <Typography variant="h6" fontWeight="bold">
                            Error
                        </Typography>
                    </DialogTitle>

                    {/* Error Message */}
                    <DialogContent>
                        <Typography id="error-dialog-description" align="center">
                           Please add billing information to download documents.
                        </Typography>
                    </DialogContent>

                    {/* Close Button */}
                    <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ backgroundColor: "#c63037", border: "none" }}
                            onClick={() => setErrorpopup(false)}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
      {/* <Dialog open={open} onClose={() => setopen(false)} fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Confirm Logout
          <IconButton onClick={() => setopen(false)}>
            <IconX size={24} />
          </IconButton>
        </DialogTitle>
        <Divider />

        <DialogContent sx={{ textAlign: "center" }}>
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <IconButton sx={{ backgroundColor: "#ffe7da", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
              <IconLogout2 color="#f5945c" size={50} />
            </IconButton>
          </Box>
          Are you sure you want to logout?
        </DialogContent>
        <Divider />
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button onClick={() => setopen(false)} color="primary" variant="contained">
            Cancel
          </Button>
          <Button onClick={() => navigate('/')} color="error" variant="contained">
            Logout
          </Button>
        </DialogActions>
      </Dialog> */}
    </>
  );
};

export default Layout;
